module.exports = __webpack_public_path__ + "assets/img/bg-img.44ad2ff1.png";